import React, { useState, useEffect } from "react";
import { GeneralDashboard } from "../../../components/Admin/Dashboard/GeneralDashboard/GeneralDashboard";
import { useAuth } from "../../../hooks";
import { useCompany } from "../../../contexts/CompanyContext";
import { useLanguage } from "../../../contexts";
import { Company } from "../../../api";
import { isAdmin, isMaster } from "../../../utils/checkPermission";
import { ErrorAccessDenied } from "../Error";

const companyController = new Company();

export function Home() {
  const { user: { role }, accessToken } = useAuth();
  const { company } = useCompany();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const [companyName, setCompanyName] = useState("");

  useEffect(() => {
    if (!company || company === "0") { setCompanyName(""); return; }
    companyController.getCompany(accessToken, company)
      .then((res) => setCompanyName(res?.name || ""))
      .catch(() => setCompanyName(""));
  }, [company, accessToken]);

  if (!isMaster(role) && !isAdmin(role)) return <ErrorAccessDenied />;

  if (!company || company === "0") {
    return (
      <div className="welcome-selector">
        <div className="welcome-selector__card">
          <h1 className="welcome-selector__title">BIENVENIDOS</h1>
          <p className="welcome-selector__subtitle">
            {t("select_company_site_from_header")}
          </p>
        </div>
      </div>
    );
  }

  return <GeneralDashboard company={company} companyName={companyName} />;
}
